import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { PreparationDetModel, PreparationDetNurseModel } from '../models/PreparationDetModel';
import { LocalStorageService } from 'ngx-webstorage';
import { URLsConfig } from '../URLsConfig';
import { ProtocolDetModel } from '../models/ProtocolDetModel';
@Injectable()
export class PreparationDetService {
  constructor(private http: HttpClient, public urlsconfig: URLsConfig) {}

  public AddPrepDet(PrepDet: ProtocolDetModel[], prepmasterID: string,patientID: string) {
    let params = new HttpParams();
    params = params.append('prepmasterID', prepmasterID);
    params = params.append('patientID', patientID);
    const options = {
      params: params,
    };
    return this.http.post<PreparationDetModel>(
      this.urlsconfig.WebAPIURL_Test + 'api/PrepDetails/AddPreparationDet',
      PrepDet,
      options
    );
  }
  ///

  public AddPrepDetAll(PrepDet: PreparationDetModel[]) {

    return this.http.post<PreparationDetModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/PrepDetails/AddPreparationDetCopy',PrepDet);
  }
public getPrepDetCat(prepmasterID: string , category: string ,compCode: string) {
    let params = new HttpParams();
      params = params.append("prepmasterID", prepmasterID);
      params = params.append("category", category);
      params = params.append("compCode", compCode);

      const options = {params: params};
    return this.http.get<PreparationDetModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/PrepDetails/GetPrepDet',options);
  }
  public getPrepDetNurseCat(prepmasterID: string , category: string ,compCode: string) {
    let params = new HttpParams();
      params = params.append("prepmasterID", prepmasterID);
      params = params.append("category", category);
      params = params.append("compCode", compCode);

      const options = {params: params};
    return this.http.get<PreparationDetNurseModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/PrepDetails/GetPrepDetNurse',options);
  }

public getPrepDetCat_Sup(prepmasterID: string , category: string ,compCode: string) {

  let params = new HttpParams();
    params = params.append("prepmasterID", prepmasterID);
    params = params.append("category", category);
    params = params.append("compCode", compCode);

    const options = {params: params};
  return this.http.get<PreparationDetModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/PrepDetails/GetPrepDet_Sup',options);
}

  public AddPrepDetCat_Line(prepDet1: PreparationDetModel) {
    return this.http.post<PreparationDetModel>(this.urlsconfig.WebAPIURL_Test + 'api/PrepDetails/AddPrepDet_Cat_Line', prepDet1);
}

  public delPrepDetAll(prepmasterID: string,compCode: string ) {

    let params = new HttpParams();
      params = params.append("prepmasterID", prepmasterID);
      params = params.append("compCode", compCode);
      const options = {
        params: params
    };
    return this.http.get<PreparationDetModel>(this.urlsconfig.WebAPIURL_Test + 'api/PrepDetails/DeletePrepDetAll',options);
  }

public DeletePrepDetLine(prepautoserial: number, category: string, drgserial: string, compCode: string ) {
  let params = new HttpParams();
    params = params.append("prepautoserial", prepautoserial);
    params = params.append("category", category);
    params = params.append("drgserial",drgserial);
    params = params.append("compCode", compCode);
    const options = {
      params: params
  };

  return this.http.get<PreparationDetModel>(this.urlsconfig.WebAPIURL_Test + 'api/PrepDetails/DeletePrepDetLine',options);

}
public DeletePrepDetLineSupp(prepautoserial: number,  drgserial: string, compCode: string ) {
  let params = new HttpParams();
  params = params.append("prepautoserial", prepautoserial);
  params = params.append("drgserial",drgserial);
  params = params.append("compCode", compCode);
  const options = {
      params: params
  };
  return this.http.get<PreparationDetModel>(this.urlsconfig.WebAPIURL_Test + 'api/PrepDetails/DeletePrepDetLineSupp',options);
}


}
